// 密码登陆
<template>
  <div id="app">
    <div class="container">
      <div class="title">登录</div>
      <div class="form">
        <div class="logo">
          <img src=".././assets/img/logo.png" />
        </div>
        <div class="textbox">
          <img src=".././assets/img/手机.png" alt />
          <input type="text" placeholder="请输入手机号" v-model="mobile" @focus="getFocus" />
        </div>
        <div class="textbox">
          <img src=".././assets/img/密码.png" alt />
          <span v-show="show" class="getCode" @click="getCode">获取验证码</span>
          <span v-show="!show" class="getCode1">{{count}} s</span>
          <input
            type="password"
            placeholder="请输入验证码"
            v-model="code"
            @focus="getFocus"
            style="padding-right:30%"
          />
        </div>
        <div class="code">
          <span @click="pwdLogin">账号密码登陆</span>
        </div>
      </div>
      <img src=".././assets/img/按钮.png" class="btn" @click="login" />
    </div>
  </div>
</template>
<script>
import qs from "qs";
import {pswLogin, sendCode } from "@/api";
export default {
  data() {
    return {
      show: true,
      count: "",
      mobile: "",
      code: ""
    };
  },
  created() {
    let token = window.localStorage.getItem("token");
    if (token == null) {
      console.log("未登录");
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    // 点击获取快捷登陆验证码
    async getCode() {
      //手机号验证
      var reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
      if (this.mobile == "") {
        this.$toast({ message: "请输入手机号码", duration: "3000" });
      } else if (!reg.test(this.mobile)) {
        this.$toast({ message: "手机格式不正确", duration: "3000" });
      } else {
        window.sessionStorage.setItem('unique',this.mobile)
        let params = {
          mobile: this.mobile,
          scene: 8
        };
        let res = await sendCode(params);
        if (res.status === 1) {
          this.$toast({ message: res.msg, duration: "3000" });
          //验证码发送成功  进入倒计时
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        } else {
          this.$toast({ message: res.msg, duration: "3000" });
        }
      }
    },
    // 跳转账号密码登陆页面
    pwdLogin() {
      this.$router.push("/login");
    },
    //点击登陆按钮进行登陆
    async login() {
      //手机号验证
      var reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
      let params = {
        account: this.mobile,
        passwd: this.code,
        scene: 8,
        unique:this.mobile,
        version:"2.3.2"
      };
      if (this.mobile == "") {
        this.$toast({ message: "请输入手机号码", duration: "3000" });
      } else if (!reg.test(this.mobile)) {
        this.$toast({ message: "手机格式不正确", duration: "3000" });
      } else if (this.passwd == "") {
        this.$toast({ message: "请输入验证码", duration: "3000" });
      } else { 
        let res = await pswLogin(qs.stringify(params))
        if(res.status===1){
           window.localStorage.setItem('token',res.result.token)
          this.$router.go(-1)
        }else{
          this.$toast({message:res.msg,duration:'3000'}) 
        }
      }
    },
    // 键盘消失后页面回弹
    getFocus() {
      let input = document.getElementsByTagName("input");
      input.blur = function() {
        window.scroll(0, 0);
      };
    }
  }
};
</script>

<style lang="less" scoped>
#app {
  width: 750px;
  height: 80vh;
  background-color: #ffffff;
  .container {
    padding: 0 62px 0 68px;
    .title {
      font-size: 16px;
      height: 120px;
      text-align: center;
      line-height: 120px;
      margin-bottom: 80px;
    }
    .form {
      position: relative;
      .logo {
        margin: 0 auto;
        width: 429px;
        height: 131px;
        margin-bottom: 150px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .textbox {
        position: relative;
        img {
          position: absolute;
          bottom: 20px;
          left: 0;
        }
        input {
          outline: none;
          -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
          width: 600px;
          margin-top: 60px;
          padding: 0 0 20px 50px;
          border: none;
          font-size: 16px;
          border-bottom: 2px solid #dddddd;
          box-shadow: inset 0 0 0 1000px #ffffff !important;
          box-sizing: border-box;
        }
        .getCode {
          position: absolute;
          right: 20px;
          bottom: 20px;
          width: 150px;
          height: 60px;
          border-radius: 3px;
          text-align: center;
          line-height: 60px;
          background-color: #ff544f;
          color: #ffffff;
        }
        .getCode1 {
          position: absolute;
          right: 20px;
          bottom: 20px;
          width: 80px;
          height: 60px;
          border-radius: 5px;
          text-align: center;
          line-height: 60px;
          background-color: #ababab;
          color: #ffffff;
        }
      }
      .code {
        width: 100%;
        height: 80px;
        line-height: 80px;
        text-align: right;
        padding: 0 20px;
        box-sizing: border-box;
        span {
          float: right;
          text-align: right;
          width: 160px;
        }
      }
    }
    .btn {
      margin-top: 90px;
      width: 620px;
      height: 90px;
    }
  }
}
</style>
